import { resourceCards } from '@/mocks/vigorbuy';
import { Link } from 'react-router-dom';

export default function ResourcesSection() {
  return (
    <section id="resources" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Resources
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 tracking-tight">
            VigorBuy Resources
          </h2>
          <p className="mt-4 text-base text-foreground-600 max-w-xl mx-auto">
            Everything you need to shop smarter — organized guides, comparisons, and safety tips
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {resourceCards.map((card, idx) => (
            <Link
              key={card.title}
              to={card.link}
              className={`group relative rounded-lg overflow-hidden ${
                idx === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
            >
              <div className={`${idx === 0 ? 'aspect-[16/9] md:aspect-auto md:h-full' : 'aspect-[4/5]'}`}>
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  title={`${card.title} - VigorBuy Spreadsheet`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 rounded-md bg-accent-500/30 flex items-center justify-center">
                    <i className={`${card.icon} text-accent-200 text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 tracking-tight">
                    {card.title}
                  </h3>
                </div>
                <p className="text-sm text-background-200 max-w-md">
                  {card.description}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-3 text-xs font-semibold text-accent-300 whitespace-nowrap">
                  Read More
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}